import { MouseEventHandler, ReactNode } from 'react';

import MUILoadingButton from '@mui/lab/LoadingButton';
import { SxProps, Theme } from '@mui/material';
import MUIButton, { ButtonPropsVariantOverrides } from '@mui/material/Button';
import { OverridableStringUnion } from '@mui/types';

import useHasPermission from '../../hooks/useHasPermission';

export interface ButtonProps {
    hidden?: boolean;
    permission?: string;
    loading?: boolean;
    startIcon?: ReactNode;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    label?: string;
    sx?: SxProps<Theme>;
    variant?: OverridableStringUnion<
        | 'text'
        | 'outlined'
        | 'contained'
        | 'npi-primary'
        | 'main'
        | 'back-button'
        | 'outlined-black',
        ButtonPropsVariantOverrides
    >;
    children?: string;
    dataTestId?: string;
    disabled?: boolean;
    type?: string;
}

// TODO: (KM) This button needs rework to reflect the new designs for primary and secondary buttons (contained & outlined)
export const Button = ({
    hidden,
    permission,
    startIcon,
    onClick,
    label,
    loading,
    sx,
    variant = 'npi-primary',
    children,
    dataTestId = `${label}-button`,
    disabled,
    type = 'button',
}: ButtonProps) => {
    const hasPermission = useHasPermission(permission);

    if (hidden || !hasPermission) {
        return null;
    }

    if (loading) {
        return (
            <MUILoadingButton
                disabled={disabled}
                data-testid={dataTestId}
                startIcon={startIcon}
                loading={loading}
                variant={variant}
                type={type}
                sx={sx}
                onClick={onClick}
            >
                {label ?? children}
            </MUILoadingButton>
        );
    }

    return (
        <MUIButton
            disabled={disabled}
            data-testid={dataTestId}
            startIcon={startIcon}
            variant={variant}
            type={type}
            sx={sx}
            onClick={onClick}
        >
            {label ?? children}
        </MUIButton>
    );
};

export default Button;
